<template>
    <DropdownV2 v-if="ai != null && available.length > 0" :menuSpace="8" buttonCSS="icon-hover" class="z-[1000]" forceSide="right">
        <template #button>
            <IconZap class="" />
        </template>

        <template #menu>
            <div class="table-multi-select-menu bg-black min-w-[260px]">
                <div class="flex items-center mx-4 pb-3 pt-1 border-b border-white/10">
                    <IconZap class="stroke-grey-800" />
                    <p class="text-14 text-grey-800 pl-2">Call Assistant feedback</p>
                </div>

                <div class="pt-2">
                    <template v-for="(value, key) in available">
                        <div class="px-4 h-8 flex items-center justify-between">
                            <p>{{ value }}</p>

                            <div class="grid grid-cols-2 gap-2">
                                <button type="text" @click="click(key, true)">
                                    <IconSmile
                                        :class="[
                                            selected[key] === true ? 'fill-green-500 stroke-green-500' : 'stroke-grey-900 fill-grey-900',
                                        ]"
                                        class="w-4.5 h-4.5"
                                    />
                                </button>

                                <button type="text" @click="click(key, false)">
                                    <IconSad
                                        :class="[selected[key] === false ? 'fill-red-700 stroke-red-700' : 'stroke-grey-900 fill-grey-900']"
                                        class="w-4.5 h-4.5"
                                    />
                                </button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </DropdownV2>
</template>

<script>
export default {
    props: {
        ai: {
            type: Object,
            default: null,
        },
        model: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            data: null,
            selected: {},
            updateInterval: null,
            available: [],
        }
    },

    methods: {
        click(key, value) {
            this.selected[key] = this.selected[key] == value ? null : value

            this.update()
        },

        update() {
            clearInterval(this.updateInterval)

            this.updateInterval = setInterval(() => {
                clearInterval(this.updateInterval)

                this.$axios.post('/ai/' + this.ai.id, {
                    verify: JSON.stringify(this.selected),
                })
            }, 1000)
        },
    },

    mounted() {
        if (this.ai != null) {
            this.data = this.ai.body
            this.selected = this.ai.verify != null ? JSON.parse(this.ai.verify) : {}

            for (let key in this.model.aiValidate()) {
                if (this.data[key] != null && this.data[key] != '') {
                    this.available.push(this.model.aiValidate()[key])
                }
            }
        }
    },
}
</script>
